import { CREATE_ACCOUNT_REQUEST, CREATE_ACCOUNT_SUCCESS, CREATE_ACCOUNT_FAILURE } from '../constants/account.constants';

const initialState = {
    loading: false,
    hasSignedUp: false,
    error: null,
};

export const Register_form = (state = initialState, action) => {
    switch (action.type) {
    case CREATE_ACCOUNT_REQUEST:
        return {
            ...state,
            hasSignedUp: false,
            loading: true,
        };
    case CREATE_ACCOUNT_SUCCESS:
        return {
            ...state,
            loading: false,
            hasSignedUp: true,
            params: action.params,
        };
    case CREATE_ACCOUNT_FAILURE:
        return {
            ...state,
            loading: false,
            hasSignedUp: false,
            error: action.error,
        };
    default:
        return state;
    }
};



// WEBPACK FOOTER //
// ./src/modules/App/redux/reducers/create_account.reducers.js